import {
  GET_ROI_VALUES_REQUEST,
  GET_ROI_VALUES_SUCCESS,
  GET_ROI_VALUES_FAILURE
} from "./roi-values-actions";

import _ from "lodash";
import createReducer from "state/createReducer";

const initialState = {
  getRequest: false,
  updateRequest: false,
  values: {}
}

const handlers = {
  [GET_ROI_VALUES_REQUEST](state) {
    return {
      ...state,
      getRequest: true
    }
  },
  [GET_ROI_VALUES_SUCCESS](state, payload) {
    if ( payload === null ) {
      return {
        ...state,
        values: {},
        getRequest: false
      }
    }

    return {
      ...state,
      values: payload,
      getRequest: false
    }
  },
  [GET_ROI_VALUES_FAILURE](state) {
    return {
      ...state,
      values: {},
      getRequest: false
    }
  },
};

export default (state = initialState, action) => createReducer(state, action, handlers);